import { lazy } from 'react';

import { createFeatureFlags, isStand } from '@packages/feature-flags';
import { env } from '@packages/runtime-config';
import { featureFlagDefinitions } from '@shared/config/feature-flags';

// Read at startup: one image serves every stand. The container does not start without
// APP_STAND (docker/40-runtime-config.sh). Without a stand, e.g. if config.js failed to load,
// the prod stand: the most stable code, and no overrides.
const stand = isStand(env.STAND) ? env.STAND : 'prod';

// Overrides (devtools) are for development and QA stands only:
// in production they would let anyone turn on unfinished features.
const overridesEnabled = stand !== 'prod';

// Types flag names in useFeatureFlag, <Feature> and isEnabled. It lives here, not next to the
// definitions, so that e2e can import the definitions of both apps into one program.
declare module '@packages/feature-flags' {
  interface Register {
    flags: typeof featureFlagDefinitions;
  }
}

export const featureFlags = createFeatureFlags(featureFlagDefinitions, {
  stand,
  overrides: overridesEnabled,
});

// One image serves every stand, so the chunk is always built; production users never load it.
export const FeatureFlagsDevtools = overridesEnabled
  ? lazy(() =>
      import('@packages/feature-flags/devtools').then(module => ({
        default: module.FeatureFlagsDevtools,
      }))
    )
  : null;
